<script  lang="ts">
    import { UserRole } from "@frontend/walletapi";
    import AddUserForm from "./AddUserForm.svelte";

    export let dismiss: () => void;
    
</script>

<AddUserForm role={UserRole.Admin} dismiss={dismiss} />